import { FC } from 'react';

import { localeCommon } from '@lib/tools/locale/source/web/common';
import { VH_VARIANTS } from '@lib/tools/shared/helpers/consts';

import CookieGif from '@components/web/src/assets/gif/biscuit.gif';
import Button from '@components/web/src/atoms/Buttons/Button';
import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { Text } from '@components/web/src/foundations/Text/Text';
import { COLORS } from '@components/web/src/styles';
import { LoadingSpinner } from '@components/web/src/templates/Loading/LoadingSpinner/LoadingSpinner';
import * as S from '@components/web/src/templates/Modals/BasicServiceTermsModal/styles';
import { ModalWrapper } from '@components/web/src/templates/Modals/ModalWrapper/ModalWrapper';

interface IProps {
  isModalOpen: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  handleRejectOptionalBasicServiceTerms: () => void;
  handleAcceptAllBasicServiceTerms: () => void;
  handleOpenGeneralServiceTermsPage: () => void;
}

export const BasicServiceTermsModal: FC<IProps> = ({
  isModalOpen,
  isLoading = false,
  handleRejectOptionalBasicServiceTerms,
  handleAcceptAllBasicServiceTerms,
  handleOpenGeneralServiceTermsPage,
}) => {
  const { descriptionText, acceptAllBtn, manageBtn, rejectBtn } = localeCommon.basicServiceTermsModal;

  return (
    <ModalWrapper isOpen={isModalOpen} justifyModalContent="flex-end" minModalContentHeight="100%">
      <S.BasicServiceTermsModalContainer direction="column" gap={16} padding="16px">
        <S.DescriptionContainer gap={0}>
          <Text color={COLORS.base.black} size="body1" text={descriptionText} />
          <div>
            <img alt="cookie-gif" src={CookieGif} />
          </div>
        </S.DescriptionContainer>
        <Button
          fontSize="subtitle2"
          handleClick={handleAcceptAllBasicServiceTerms}
          size="lg"
          text={acceptAllBtn}
          textWeight="medium"
          variant={VH_VARIANTS.PRIMARY}
        />
        <Flexbox isFullWidth gap={10}>
          <Button
            isFullWidth
            fontSize="subtitle2"
            handleClick={handleOpenGeneralServiceTermsPage}
            size="md"
            text={manageBtn}
            textWeight="medium"
            variant={VH_VARIANTS.LIGHT}
          />
          <Button
            isFullWidth
            fontSize="subtitle2"
            handleClick={handleRejectOptionalBasicServiceTerms}
            size="md"
            text={rejectBtn}
            textWeight="medium"
            variant={VH_VARIANTS.LIGHT}
          />
        </Flexbox>
        {isLoading && <LoadingSpinner />}
      </S.BasicServiceTermsModalContainer>
    </ModalWrapper>
  );
};
